






























































import { Component, Prop, Vue } from 'vue-property-decorator'
import BuilderDeviceHighlight from '@/components/builder/BuilderDeviceHighlight.vue'

@Component({
  components: {
    BuilderDeviceHighlight,
  },
})
export default class BuilderDeviceProfileHeaderStub extends Vue {
  @Prop({ default: 'Site Name', type: String }) siteName!: string

  @Prop({ required: true, type: String }) color!: string

  @Prop({ default: false, type: Boolean }) highlight!: boolean

  get formattedSiteName(): string {
    return this.siteName ? this.siteName : 'Your Site'
  }
}
